import SectionHeading from "@/components/base/SectionHeading";
import { quickSteps, reasons } from "@/mocks/homeContent";

export default function QuickStart() {
  return (
    <section id="install" className="scroll-mt-24 w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="下载安装总览"
          title="三步走完：获取安装包到进入社区"
          desc="无论使用安卓还是苹果手机，安装逻辑都可以拆成准备、授权、登录三件事。先看整体流程，再按你的手机系统查看详细步骤。"
        />

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-5">
            {quickSteps.map((item) => (
              <div
                key={item.step}
                className="bg-background-100 border border-background-200 rounded-lg p-5 flex flex-col"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center text-xl">
                    <i className={item.icon} aria-hidden="true"></i>
                  </span>
                  <span className="font-heading text-2xl font-bold text-background-400">
                    {item.step}
                  </span>
                </div>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="relative rounded-lg overflow-hidden border border-background-200 min-h-[260px] lg:min-h-full">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20showing%20a%20short%20video%20streaming%20app%20interface%2C%20warm%20amber%20and%20green%20accent%20user%20interface%2C%20clean%20minimal%20layout%20on%20soft%20cream%20background%2C%20studio%20product%20photography%2C%20high%20detail&width=800&height=1000&seq=durian-app-phone-01&orientation=portrait"
              alt="榴莲视频应用界面在手机上的展示示意"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-foreground-950/85 to-transparent p-5">
              <p className="text-sm font-medium text-background-50">
                安装完成后即可进入兴趣视频社区
              </p>
              <p className="mt-1 text-xs text-background-200">
                浏览、弹幕、缓存、创作，一个应用全部搞定
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
          {reasons.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-3 bg-background-100/70 border border-background-200 rounded-lg p-5"
            >
              <span className="w-10 h-10 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center text-xl">
                <i className={item.icon} aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-600">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}